// extracted by mini-css-extract-plugin
export default {"boxed-input-text":"boxed-input-text","input-label":"input-label","input-instructions":"input-instructions","input-text-container":"input-text-container","input-text":"input-text"};